import { render, staticRenderFns } from "./PdfIndextab4.vue?vue&type=template&id=04cea3c6"
import script from "./PdfIndextab4.vue?vue&type=script&lang=js"
export * from "./PdfIndextab4.vue?vue&type=script&lang=js"
import style0 from "./PdfIndextab4.vue?vue&type=style&index=0&id=04cea3c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports